export const fetchManualData = async () => {
  const conn_name = "crmwidgetconnection";
  const apiUrl =
    "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Quality_Manual_Report";

  const req_data = {
    method: "GET",
    url: apiUrl,
    param_type: 1,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, req_data);

    if (!response || !response.details || !response.details.statusMessage) {
      console.error("❌ Invalid response structure:", response);
      return [];
    }

    let records = response.details.statusMessage.data;

    // ✅ Handle case where records is not an array
    if (!Array.isArray(records)) {
      console.warn("⚠️ Fetched data is not an array, wrapping it in an array.");
      records = [records];
    }

    console.log("✅ Parsed Quality Manual Records:", records);

    return records.map((item) => ({
      id: item.ID,
      versionNumber: item.Version_Number || "No version available",
      revisionNotes: item.Revision_Notes || "No revision notes available",
      approvalAuthority: item.Approval_Authority || "No approval authority",
      controlledCopyLink: item.Controlled_Copy_Link || "No link available",
      effectiveDate: item.Effective_Date || "No effective date",
      ...item,
    }));
  } catch (error) {
    console.error("❌ Error fetching Quality Manual data:", error);
    return [];
  }
};
